import Axios from "axios";
import {
  SET_PRODUCTION_CUTTING_LIST,
  UNSET_PRODUCTION_CUTTING_LIST,
} from "@/store/mutation-types";
import { cuttingResource, cuttingableProductionOrderResource } from "@/store/api";

// Initial State
const state = {
  getProductionCuttingList: [],
  getCuttingableProductionOrderList: [],
};

// Getters
const getters = {
  getProductionCuttingList(state) {
    return state.getProductionCuttingList;
  },
  getCuttingableProductionOrderList(state) {
    return state.getCuttingableProductionOrderList;
  },
};

// Mutations
const mutations = {
  [SET_PRODUCTION_CUTTING_LIST](state, data) {
    state.getProductionCuttingList = data;
  },
  [UNSET_PRODUCTION_CUTTING_LIST](state) {
    state.getProductionCuttingList = [];
  },
  SET_CUTTINGABLE_PRODUCTION_ORDER_LIST(state, data) {
    state.getCuttingableProductionOrderList = data;
  },
  UNSET_CUTTINGABLE_PRODUCTION_ORDER_LIST(state) {
    state.getCuttingableProductionOrderList = [];
  },
};

// Actions
const actions = {
  // GET LIST
  getProductionCuttingList({ commit }) {
    return new Promise((resolve, reject) => {
      Axios.get(cuttingResource)
        .then((response) => {
          commit(SET_PRODUCTION_CUTTING_LIST, response.data.data);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_PRODUCTION_CUTTING_LIST);
          reject(error);
        });
    });
  },

  // CREATE
  saveProductionCutting({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.post(cuttingResource, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  // UPDATE
  updateProductionCutting({ commit }, { id, data }) {
    commit("SET_LOADING", { color: "primary" });
    const url = `${cuttingResource}/${id}`;

    return new Promise((resolve, reject) => {
      Axios.put(url, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  // GET BY ID
  getProductionCuttingById({ commit }, id) {
    return new Promise((resolve, reject) => {
      const url = `${cuttingResource}/${id}`;
      Axios.get(url)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // GET CUTTINGABLE PRODUCTION ORDERS
  getCuttingableProductionOrderList({ commit }) {
    return new Promise((resolve, reject) => {
      Axios.get(cuttingableProductionOrderResource)
        .then((response) => {
          commit("SET_CUTTINGABLE_PRODUCTION_ORDER_LIST", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          commit("UNSET_CUTTINGABLE_PRODUCTION_ORDER_LIST");
          reject(error);
        });
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
